"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.number.constructor");
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _ossUpload = require("@/utils/ossUpload");
var _popupManagement = require("@/api/operationManagement/popupManagement");
var _ActivitySelectionPopup = _interopRequireDefault(require("../../appRenovation/component/components/ActivitySelectionPopup"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PopupOperation',
  components: {
    ActivitySelectionPopup: _ActivitySelectionPopup.default
  },
  data: function data() {
    // var validateArrayNotEmpty = (rule, value, callback) => {
    //   if (value && value.length > 0) {
    //     callback() // 验证成功
    //   } else {
    //     callback(new Error('最少选择一项')) // 验证失败
    //   }
    // }
    return {
      value1: [],
      dialogVisible: false,
      ruleForm: {
        popType: 1,
        id: null,
        pic: '',
        name: '',
        enable: null,
        num: 1,
        sort: null,
        region: 1,
        userType: null,
        jumpType: 2,
        grade: null,
        jumpContent: '',
        // url
        activityId: null,
        activityName: '',
        activityType: '',
        interPageFlag: 1,
        startTime: '',
        endTime: '',
        startDate: '',
        endDate: '',
        openUrl: ''
      },
      rules: {
        pic: [{
          required: true,
          message: '请上传图片',
          trigger: 'blur'
        }, {
          min: 1,
          max: 500,
          message: '请上传图片',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }, {
          min: 0,
          max: 99,
          message: '长度在 0 到 99 个字符',
          trigger: 'blur'
        }],
        enable: [{
          required: true,
          message: '请选择上下线',
          trigger: 'change'
        }],
        num: [{
          type: 'number',
          required: true,
          message: '请输入每日弹出次数'
        }],
        sort: [{
          type: 'number',
          required: true,
          message: '请输入排序'
        }],
        jumpContent: [{
          required: true,
          message: '请输入URL',
          trigger: 'blur'
        }, {
          min: 1,
          max: 500,
          message: '请输入URL',
          trigger: 'blur'
        }]
        // region: [
        //   { validator: validateArrayNotEmpty, trigger: 'blur' }
        // ]
        // userType: [
        //   { validator: validateArrayNotEmpty, trigger: 'blur' }
        // ]
      },
      timeArray: [],
      presentationData: {
        Display_type: null,
        // 判断展示方式
        unionCode: null,
        activityType: null,
        activityImg: null,
        isActivityShow: false
      },
      addEndEditor: '',
      // 弹窗类型
      title: '',
      // 弹窗name
      classListData: [],
      classListQuery: []
    };
  },
  methods: {
    open: function open(data) {
      this.classListApi();
      this.addEndEditor = data.type;
      this.title = data.name;
      if (data.type === 'editor') {
        this.getPopupByIdApi(data.id);
      }
      this.dialogVisible = true;
    },
    onClose: function onClose() {
      var _this = this;
      this.onInit();
      this.onInitPresentationData();
      this.ruleForm.id = null;
      this.addEndEditor = '';
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible = false;
      this.$nextTick(function () {
        _this.$refs.dialogContent.scrollTop = 0;
      });
    },
    // 主图
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              this.ruleForm.pic = pictureUrl;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    onJumpTypeToggle: function onJumpTypeToggle(value) {
      var formName = 'ruleForm';
      this.$refs[formName].clearValidate('jumpContent');
      if (value === 2) {
        this.ruleForm.activityId = null;
        this.ruleForm.activityName = '';
        this.ruleForm.activityType = '';
        this.ruleForm.interPageFlag = 0;
        this.presentationData = {
          Display_type: null,
          unionCode: null,
          activityType: null,
          activityImg: null,
          isActivityShow: false
        };
      } else if (value === 3) {
        this.jumpContent = '';
      }
    },
    // 选择活动
    onOfficialEvent: function onOfficialEvent() {
      this.ruleForm.activityId = null;
      this.ruleForm.activityName = '';
      this.ruleForm.activityType = '';
      this.ruleForm.interPageFlag = 0;
      this.onInitPresentationData();
      this.$refs.activitySelectionPopup.open();
    },
    // 展示重置
    onInitPresentationData: function onInitPresentationData() {
      this.presentationData = {
        Display_type: null,
        unionCode: null,
        activityType: null,
        activityImg: null,
        isActivityShow: false
      };
    },
    // 参数重置
    onInit: function onInit() {
      this.ruleForm.pic = '';
      this.ruleForm.name = '';
      this.ruleForm.enable = null;
      this.ruleForm.num = null;
      this.ruleForm.sort = null;
      this.ruleForm.region = 1;
      this.ruleForm.userType = null;
      this.ruleForm.jumpType = 2;
      this.ruleForm.grade = null;
      this.ruleForm.jumpContent = '';
      this.ruleForm.activityId = null;
      this.ruleForm.activityName = '';
      this.ruleForm.activityType = '';
      this.ruleForm.interPageFlag = 1;
      this.ruleForm.startTime = '';
      this.ruleForm.endTime = '';
      this.ruleForm.startDate = '';
      this.ruleForm.endDate = '';
      this.timeArray = [];
      this.classListQuery = [];
    },
    // 自定义货多功能回传
    onSelectEvents: function onSelectEvents(data) {
      console.log(data, '=========');
      this.presentationData.isActivityShow = true;
      this.presentationData.activityType = data.Display_name;
      this.presentationData.Display_type = data.Display_type;
      this.ruleForm.activityType = data.Display_type;
      this.ruleForm.openUrl = data.openUrl ? data.openUrl : '';
      if (data.Display_type === 1 || data.Display_type === 2) {
        // 自定义活动，官方活动 回填
        // 本地展示
        this.presentationData.unionCode = data.unionCode;
        this.presentationData.activityImg = data.mainImage;
        // 参数
        this.ruleForm.activityName = data.name;
        this.ruleForm.activityId = data.id;
        this.ruleForm.interPageFlag = 1;
      } else if (data.Display_type === 3) {
        // 聚合页活动回填
        this.ruleForm.activityName = data.name;
        this.ruleForm.activityId = data.id;
        this.presentationData.activityImg = data.activityList[0].activityPic;
      } else if (data.Display_type === 4) {
        // 通用H5活动 回填
        this.ruleForm.activityName = data.name;
        this.ruleForm.activityId = data.pageId;
      } else if (data.Display_type === 5) {
        this.ruleForm.activityName = data.title;
        this.ruleForm.activityId = data.id;
      } else if (data.Display_type === 10) {
        this.ruleForm.activityName = data.name;
        this.ruleForm.activityId = data.pageId;
      } else if (data.Display_type === 6) {
        this.presentationData.unionCode = data.platformCode;
        this.ruleForm.activityName = data.activityName;
        this.ruleForm.activityId = data.id;
        this.presentationData.activityImg = data.picUrl;
      } else if (data.Display_type === 7) {
        // 第三方 代下单  回填
        this.presentationData.activityImg = data.mainImage;
        // 参数
        this.ruleForm.activityName = data.name;
        this.ruleForm.activityId = data.id;
      } else if (data.Display_type === 8) {
        this.ruleForm.activityName = data.activityName;
        this.ruleForm.activityId = data.id;
        this.presentationData.unionCode = data.platformCode;
        this.presentationData.activityImg = data.headerPic;
      } else if (data.Display_type === 9) {
        console.log('data----', data);
        /**
         * （流程三）
         */
        this.ruleForm.activityName = data.activityName;
        this.ruleForm.activityId = data.id;
        this.presentationData.unionCode = data.platformCode;
        this.presentationData.activityImg = data.mainPic;
      }
    },
    submitForm: function submitForm(formName) {
      var _this2 = this;
      if (this.ruleForm.jumpType === 3) {
        if (!this.ruleForm.activityId) {
          this.$message.error('请选择活动');
          return false;
        }
      }
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this2.addEndEditor === 'add') {
            _this2.savePopupApi();
          } else {
            _this2.updatePopupApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.onInit();
      this.onInitPresentationData();
      this.$refs[formName].resetFields();
    },
    // 等级查询
    classListApi: function () {
      var _classListApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = {};
              _context2.n = 1;
              return (0, _popupManagement.classListApi)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                console.log('res', res);
                this.classListData = res.data;
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function classListApi() {
        return _classListApi2.apply(this, arguments);
      }
      return classListApi;
    }(),
    // 新增
    savePopupApi: function () {
      var _savePopupApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              if (this.ruleForm.jumpType === 2) {
                this.ruleForm.openUrl = this.ruleForm.jumpContent;
              }
              params = (0, _objectSpread2.default)({}, this.ruleForm); // params.region = params.region.join(',')
              // params.userType = params.userType.join(',')
              if (this.timeArray && this.timeArray[0]) {
                params.startDate = this.timeArray[0];
                params.endDate = this.timeArray[1];
              }
              if (this.ruleForm.userType === 3) {
                params.grade = this.classListQuery.join(',');
              } else {
                params.grade = null;
              }
              _context3.n = 1;
              return (0, _popupManagement.savePopupApi)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '添加成功'
                });
                this.$emit('refresh');
                this.onClose();
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function savePopupApi() {
        return _savePopupApi2.apply(this, arguments);
      }
      return savePopupApi;
    }(),
    // 编辑
    updatePopupApi: function () {
      var _updatePopupApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var params, res, _t4;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              if (this.ruleForm.jumpType === 2) {
                this.ruleForm.openUrl = this.ruleForm.jumpContent;
              }
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              if (this.timeArray && this.timeArray[0]) {
                params.startDate = this.timeArray[0];
                params.endDate = this.timeArray[1];
              }
              // params.region = params.region.join(',')
              if (this.ruleForm.userType === 3) {
                params.grade = this.classListQuery.join(',');
              } else {
                params.grade = null;
              }
              // params.userType = params.userType.join(',')
              _context4.n = 1;
              return (0, _popupManagement.updatePopupApi)(params);
            case 1:
              res = _context4.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '编辑成功'
                });
                this.$emit('refresh');
                this.onClose();
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              console.log(_t4);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function updatePopupApi() {
        return _updatePopupApi2.apply(this, arguments);
      }
      return updatePopupApi;
    }(),
    // 查询
    getPopupByIdApi: function () {
      var _getPopupByIdApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5(id) {
        var params, res, _t5;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              params = {
                id: id
              };
              _context5.n = 1;
              return (0, _popupManagement.getPopupByIdApi)(params);
            case 1:
              res = _context5.v;
              if (res.code === 0) {
                this.ruleForm.popType = res.data.popType ? Number(res.data.popType) : 1;
                this.ruleForm.openUrl = res.data.openUrl ? res.data.openUrl : '';
                this.ruleForm.id = res.data.id;
                this.ruleForm.pic = res.data.pic;
                this.ruleForm.name = res.data.name;
                this.ruleForm.enable = res.data.enable;
                this.ruleForm.num = res.data.num;
                this.ruleForm.sort = res.data.sort;
                // this.ruleForm.region = res.data.region.split(',').map(Number)
                this.ruleForm.region = Number(res.data.region);
                // this.ruleForm.userType = res.data.userType.split(',').map(Number)
                this.ruleForm.userType = res.data.userType ? Number(res.data.userType) : res.data.userType;
                if (this.ruleForm.userType === 3) {
                  this.classListQuery = res.data.grade.split(',');
                }
                this.ruleForm.jumpType = Number(res.data.jumpType);
                this.ruleForm.jumpContent = res.data.jumpContent;
                this.ruleForm.activityId = res.data.activityId;
                this.ruleForm.activityName = res.data.activityName;
                this.ruleForm.activityType = Number(res.data.activityType);
                this.ruleForm.interPageFlag = res.data.interPageFlag;
                this.ruleForm.startTime = res.data.startTime;
                this.ruleForm.endTime = res.data.endTime;
                // 四种类型
                if (Number(res.data.jumpType) === 3) {
                  this.presentationData.isActivityShow = true;
                  this.presentationData.activityImg = res.data.pic;
                }
                // 名字判断
                if (Number(res.data.activityType) === 1) {
                  this.presentationData.activityType = '自定义活动';
                } else if (Number(res.data.activityType) === 2) {
                  this.presentationData.activityType = '官方活动';
                } else if (Number(res.data.activityType) === 3) {
                  this.presentationData.activityType = '聚合页';
                } else if (Number(res.data.activityType) === 4) {
                  this.presentationData.activityType = '通用H5';
                } else if (Number(res.data.activityType) === 5) {
                  this.presentationData.activityType = '自定义页面';
                } else if (Number(res.data.activityType) === 8) {
                  this.presentationData.activityType = '礼金补贴活动';
                  this.presentationData.activityImg = res.data.freePurchaseActivityDTO.headerPic;
                } else if (Number(res.data.activityType) === 9) {
                  // (流程四)
                  this.presentationData.activityType = '超级补贴活动';
                  this.presentationData.activityImg = res.data.buyRestitutionActivityDTO.mainPic;
                }
                // 判断展示方式
                this.presentationData.Display_type = Number(res.data.activityType);
                // 自定义活动，官方活动 回填
                if (Number(res.data.activityType) === 1 || Number(res.data.activityType) === 2) {
                  this.presentationData.unionCode = res.data.activityDetail.unionCode;
                }
                if (res.data.endDate) {
                  this.timeArray = [res.data.startDate, res.data.endDate];
                }
              }
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t5 = _context5.v;
              console.log(_t5);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function getPopupByIdApi(_x2) {
        return _getPopupByIdApi2.apply(this, arguments);
      }
      return getPopupByIdApi;
    }()
  }
};